export default __webpack_public_path__ + "static/media/surge-1.c31e60c3.webp";